import { render, staticRenderFns } from "./ProvidersTray.vue?vue&type=template&id=fef2742c&scoped=true"
import script from "./ProvidersTray.vue?vue&type=script&lang=js"
export * from "./ProvidersTray.vue?vue&type=script&lang=js"
import style0 from "./ProvidersTray.vue?vue&type=style&index=0&id=fef2742c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef2742c",
  null
  
)

export default component.exports